export const positions = {
  UP: "up",
  DOWN: "down",
  LEFT: "left",
  RIGHT: "right"
};

export const motifs = {
  QUADRILLAGE: "Quadrillage",
  POINTS: "Points"
};
